import template from "./infoCheckbox.html";
import controller from "./infoCheckbox.controller";

export default {
	restrict: "E",
	bindings: {
		options: "=",
		form: "<",
		model: "=",
		isDisabled: "<",
	},
	transclude: true,
	template,
	controller,
	controllerAs: "vm",
};



// WEBPACK FOOTER //
// ./src/app/common/ui/infoCheckbox/infoCheckbox.component.js